export const ANALYTICS_REMOVE_MODAL = 'removePeople';
export const ANALYTICS_REMOVE_BTN = 'removePeopleButton';
